import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=270039de&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=270039de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270039de",
  null
  
)

export default component.exports